<template>
  <b-card
    no-body
    class="border mt-1"
  >
    <b-card-header class="p-1">
      <b-card-title class="font-medium-2">
        <feather-icon
          icon="SettingsIcon"
          size="18"
        />
        <span class="align-middle ml-50">User settings</span>
      </b-card-title>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col cols="6">
          <b-form-group
            label="Agent number"
            label-for="agent-number"
          >
            <validation-provider
              #default="{ errors }"
              name="Agent number"
            >
              <b-form-input
                id="agent-number"
                v-model="settings.agentNumber"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BCardHeader, BCardTitle, BCol, BFormGroup, BFormInput, BRow } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import handleError from '@/views/components/errorHandler'
import { EventBus } from '@core/utils/utils'

export default {
  components: {
    BCard,
    BCardBody,
    BCardTitle,
    BCardHeader,
    BCol,
    BRow,
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  props: {
    countryCode: {
      type: String,
      required: true,
    },
    userId: {
      type: Number,
      required: true,
    },
    companyId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      settings: {
        agentNumber: '',
      },
    }
  },
  created() {
    EventBus.$on('saveCustomsSettings', this.saveChanges)
    this.fetchUserCustomsData()
  },
  beforeDestroy() {
    EventBus.$off('saveCustomsSettings', this.saveChanges)
  },
  methods: {
    saveChanges() {
      this.$http.post(`/v1/user/customs/${this.countryCode}`, this.settings)
        .then(response => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message,
              icon: 'EditIcon',
              variant: 'success',
            },
          })
        })
        .catch(error => {
          handleError(error, this.$toast)
        })
    },
    fetchUserCustomsData() {
      this.$http.get(`/v1/user/customs/${this.countryCode}`)
        .then(response => {
          switch (this.countryCode) {
            case 'ee':
              this.$data.settings = response.data
              break
            default:
              break
          }
        })
        .catch(error => {
          handleError(error, this.$toast)
        })
    },
  },
}
</script>
